import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_ctx.modalShow)
    ? (_openBlock(), _createBlock(_component_v_dialog, {
        key: 0,
        modelValue: _ctx.modalShow,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modalShow) = $event)),
        width: "800",
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_form, {
            ref: "form",
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
          }, {
            default: _withCtx(() => [
              (_ctx.scenario && _ctx.model)
                ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, { "primary-title": "" }, {
                        default: _withCtx(() => [
                          (_ctx.originalScenario.id == _ctx.scenario.id)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t("message.editScenario")), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            density: "compact",
                            modelValue: _ctx.scenario.name,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.scenario.name) = $event)),
                            variant: "outlined",
                            label: _ctx.$t('message.scenarioName'),
                            rules: _ctx.nameRules,
                            disabled: _ctx.scenario.changeCount == 1
                          }, null, 8, ["modelValue", "label", "rules", "disabled"]),
                          (!_ctx.isScoreModel)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.$t("message.competitionDescription")) + " ", 1),
                                _createVNode(_component_v_checkbox, {
                                  density: "compact",
                                  modelValue: _ctx.scenario.competition,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.scenario.competition) = $event)),
                                  label: _ctx.$t('message.scenarioCompetition')
                                }, null, 8, ["modelValue", "label"])
                              ], 64))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("message.isTopScenarioDescription")) + " ", 1),
                          _createVNode(_component_v_checkbox, {
                            density: "compact",
                            modelValue: _ctx.scenario.isTop,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.scenario.isTop) = $event)),
                            label: _ctx.$t('message.isTopScenario')
                          }, null, 8, ["modelValue", "label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_divider),
                      _createVNode(_component_v_card_actions, null, {
                        default: _withCtx(() => [
                          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            variant: "text",
                            onClick: _ctx.save,
                            type: "submit"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("message.save")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            variant: "text",
                            onClick: _ctx.close
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("message.cancel")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}